export default "__VITE_ASSET__dnHuS6aw__"